module.exports = __webpack_public_path__ + "img/hc_pro_one_6.81627fa4.jpg";